export default __webpack_public_path__ + "static/media/night-cloud-active.3fe3e422.svg";